import { Input } from '@/components/ui/input';
import React from 'react';
import { FieldComponentProps } from './types';

export const HiddenField: React.FC<FieldComponentProps> = ({
  controllerField,
}) => {
  return <Input {...controllerField} type="hidden" />;
};
